var exports = {
  "P": "SanitizedHtml__7dBItS",
};

module.exports = exports;
